export default "__VITE_ASSET__xx39KbX5__"